export const ROUTE_PATH = '/benefits';
